export type PartnerSaveStatus = "idle" | "saving" | "saved" | "error";
export type PartnerSaveTarget = "local" | "invite" | "inviteCreation";
export type PartnerSaveStatusTone = "neutral" | "pending" | "success" | "error";

export function getPartnerSaveStatusMessage({
  saveTarget,
  saveStatus,
  uploadInProgress,
  lastSavedLabel,
}: {
  saveTarget: PartnerSaveTarget;
  saveStatus: PartnerSaveStatus;
  uploadInProgress: boolean;
  lastSavedLabel: string;
}): { tone: PartnerSaveStatusTone; message: string } {
  if (saveTarget === "inviteCreation") {
    if (saveStatus === "saving") return { tone: "pending", message: "협업 초대 링크를 만드는 중" };
    if (saveStatus === "error") return { tone: "error", message: "협업 초대 링크 생성에 실패했습니다" };
  }
  if (uploadInProgress) {
    return { tone: "pending", message: "첨부 파일을 자동 저장하는 중…" };
  }
  if (saveStatus === "saving") {
    return { tone: "pending", message: "자동 저장하는 중…" };
  }
  if (saveStatus === "error") {
    return { tone: "error", message: saveTarget === "invite" ? "이 기기에는 저장됨 · 서버 반영은 잠시 후 재시도" : "자동 저장에 실패했어요 · 잠시 후 다시 시도합니다" };
  }
  if (saveStatus === "idle") return { tone: "neutral", message: "입력하면 자동으로 저장돼요" };
  return { tone: "success", message: saveTarget === "invite" ? `✓ 자동 저장 완료 · ${lastSavedLabel}` : `✓ 이 기기에 자동 저장됨 · ${lastSavedLabel}` };
}
